import { Button, Image } from 'antd'
import { Feature, GeoJsonProperties, Point } from 'geojson'
import React, { FunctionComponent } from 'react'
import { Popup } from 'react-map-gl'
import { Link } from 'react-router-dom'

import { GOOGLE_MAPS_KEY } from '../../../../ini.json'
import { useAppSelector } from '../../../redux/hooks'
import { imageSkeleton } from '../../utils/layoutConst'
import { subjectDetailPath } from '../../utils/paths'

export const SubjectSearchResultMapPopup: FunctionComponent = () => {
  const popupData = useAppSelector(state => state.map.popupData) as Feature<
    Point,
    GeoJsonProperties
  >
  const [longitude, latitude] = popupData?.geometry?.coordinates || []
  const imageSrc = `https://maps.googleapis.com/maps/api/streetview?return_error_code=true&size=200x100&location=${latitude},${longitude}&fov=125&pitch=15&source=outdoor&key=${GOOGLE_MAPS_KEY}`

  if (!latitude || !longitude) return null

  return (
    <Popup
      longitude={longitude}
      latitude={latitude}
      closeOnClick={false}
      closeButton={false}
    >
      <div className="text-sm">
        <div className="font-semibold">{popupData.properties?.nazev}</div>
        <Link to={subjectDetailPath(popupData.properties?.id)}>
          <Image
            preview={false}
            fallback={imageSkeleton}
            src={imageSrc}
            alt="× Snímek adresy"
            className="w-full h-24 bg-gray-100 hover:opacity-80 transition-opacity rounded-sm"
            wrapperClassName="w-full h-24 mt-2 overflow-hidden !flex justify-center items-center"
          />
        </Link>
        <div className="whitespace-pre mt-2">
          {popupData.properties?.adresa?.replace(/, /g, `\n`)}
        </div>
        <Link to={subjectDetailPath(popupData.properties?.id)}>
          <Button
            className="mt-2 w-full min-w-[180px]"
            type="primary"
            ghost
            size="small"
          >
            Přejít na detail
          </Button>
        </Link>
      </div>
    </Popup>
  )
}
